export default __webpack_public_path__ + "static/media/img10.9eff3e09.PNG";